import React from "react";
import { FormControl, TextField, FormHelperText } from "@mui/material";

const Input = (props) => {
  return (
    <FormControl sx={[{ width: "100%" }, props.sx]}>
      <TextField
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "3px solid rgba(0,0,0,.1)",
            },
          },
          "& .MuiOutlinedInput-root:hover": {
            "& fieldset": {
              border: "3px solid #006156",
            },
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-input": {
            paddingLeft: "7px",
          },
          "& ::placeholder": {
            fontFamily: "Roman55",
          },
        }}
        value={props.value}
        type={props.type}
        onChange={props.onChange}
        placeholder={props.placeholder}
        InputProps={props.InputProps}
        multiline={props.multiline}
        maxRows={props.maxRows}
        rows={props.rows}
        style={props.style}
      />
      <FormHelperText sx={{ color: "#F0142F", fontFamily: "Roman55" }}>
        {props.error && props.error}
      </FormHelperText>
    </FormControl>
  );
};

export default Input;
